import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Observable, BehaviorSubject, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { RequestPaginate, RequestService } from './request.service';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';

@Injectable({
  	providedIn: 'root'
})
export class ApiService extends RequestService {

	private jwtService: JwtHelperService = new JwtHelperService();

	get baseUrl () {return 'api/'};
	get baseHeaders () {return this.token ? {'Authorization': 'Bearer '+ this.token} : {}};

	onAuthenticatedSubject: BehaviorSubject<boolean> = new BehaviorSubject(this.isAuthenticated)
	
	constructor(http: HttpClient, protected msalService: MsalService) { super(http); }

	get me (): any { return JSON.parse(localStorage.getItem('me')) }
	set me (response: any) {
		if(response) {

			let me: any = response.hasOwnProperty('me') ? response.me : this.me;
			const token = response.hasOwnProperty('token') ? response.token : this.token;

			if(token) me.token = token;

			localStorage.setItem('me', JSON.stringify(me));
		}
		else
			localStorage.removeItem('me');
	}

	get token (): string { return this.me?.token ?? null }

	get impersonated (): any { return JSON.parse(localStorage.getItem('impersonated')) }
	set impersonated (token: any) { 
		if(token) localStorage.setItem('impersonated', JSON.stringify(token));
		else localStorage.removeItem('impersonated');
	}

	get isAuthenticated (): boolean {
		return !!this.token && !new JwtHelperService().isTokenExpired(this.token)
	}

	get decodedToken (): any {
		return this.token ? this.jwtService.decodeToken(this.token) : null
	}

	get impersonateDecodedToken (): any {
		return this.impersonated ? this.jwtService.decodeToken(this.impersonated?.token) : null
	}

    pictureOf (id: string) { return `/${this.baseUrl}users/${id}/picture`; }

	onAuthenticated (): Observable<boolean> { return this.onAuthenticatedSubject.asObservable(); }

    connect (account: AccountInfo): Observable<any> {
        return this.post('users/authenticate/azure', {access_token: account.idToken}, {ignoreErrorNotifications: true}).pipe(
            map((response: any) => {
                if(response.authenticated) {
                    this.me = response;
                    this.onAuthenticatedSubject.next(response.authenticated);
                }
                return response;
            })
        );
    }

	deconnect () {
		this.me = null;
		this.impersonated = null;
		this.clearShared();
		this.onAuthenticatedSubject.next(false);
	}

	impersonate (user: {guid: string}): Observable<any> {
		if(this.decodedToken?.isGod) {
			this.clearShared();
			
			return this.post('impersonate', user)
						.pipe(
                            tap(response => {
                                if(response.token) {
                                    this.impersonated = {...this.me};
                                    this.me = null;
                                    this.me = response;
                                    this.onAuthenticatedSubject.next(true);
                                }
                            })
                        );
		} else
			return of(null);
	}

	personate () {
		if(this.impersonateDecodedToken?.isGod) {
			this.me = null;
			this.me = {me: this.impersonated, ...this.impersonated};
			this.impersonated = null;
			this.clearShared();
			this.onAuthenticatedSubject.next(true);
		}
	}

	refresh (response: any) {
		this.me = response;
		this.clearShared();
		this.onAuthenticatedSubject.next(true);
	}
}

export class ApiPaginate extends RequestPaginate<any[]> {}